/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationRatingOutput } from './oralExamSubEvaluationRatingOutput';

export type OralExamTaskEvaluationOutputSubEvaluations = { [key: string]: OralExamSubEvaluationRatingOutput };
